export default "__VITE_ASSET__c04b3e59__"